module.exports = __webpack_public_path__ + "28271722a62fb41e8f6fbed3055f9478.pdf";